import { DestinationSearch } from '../../../../apps/explore/components/DestinationSearch/DestinationSearch';
import { useTranslate } from '../../../../apps/explore/hooks/useTranslate';

type Props = {
  tripPlannerExtraQueryParams: Record<string, string>;
};

export const Content = ({ tripPlannerExtraQueryParams }: Props) => {
  const { t } = useTranslate();

  return (
    <DestinationSearch
      placeholder={t('stenaline.destinationSearch.placeholder')}
      tripPlannerExtraQueryParams={tripPlannerExtraQueryParams}
      hideAmeliaChat={true}
    />
  );
};
